import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Dialog, Classes
} from '@blueprintjs/core';
import './errors-dialog.scss';

type Props = {
  data: { connection: string, protocols: string[] },
  wasDataUpdatedWithErrors: boolean,
}

const ErrorsDialog = ({ data, wasDataUpdatedWithErrors }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setOpen(wasDataUpdatedWithErrors);
  }, [wasDataUpdatedWithErrors]);

  const handleCLose = () => {
    setOpen(false);
  }

  const renderErrorSection = (title: string, error: string) => {
    if (!error) {
      return null;
    }

    return (
      <div className="errors-dialog-section">
        <h5 className="errors-dialog-section-title">{title}:</h5>
        <ul className="errors-dialog-errors">
          <li key={error} className="errors-dialog-errors-item">{error}</li>
        </ul>
      </div>
    );
  }

  const renderProtocolsErrorSection = (title: string, errors: string[]) => {
    if (!errors?.length) {
      return null;
    }

    return (
      <div className="errors-dialog-section">
        <h5 className="errors-dialog-section-title">{title}:</h5>
        <ul className="errors-dialog-errors">
          {
            errors.map((error) => <li key={error} className="errors-dialog-errors-item">{error}</li>)
          }
        </ul>
      </div>
    );
  }

  return (
    <Dialog isOpen={isOpen} title={t('xtpXdpConnection.form.dialog.title')} onClose={handleCLose} className="errors-dialog">
      <div className="errors-dialog-body">
        <p className="errors-dialog-note">{t('xtpXdpConnection.form.dialog.note')}</p>
        <div className="errors-dialog-sections">
          {renderErrorSection(t('xtpXdpConnection.form.dialog.xtp'), data.connection)}
          {renderProtocolsErrorSection(t('xtpXdpConnection.form.dialog.xtpOptions'), data.protocols)}
        </div>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={handleCLose} intent="primary" text={t('common.button.ok')} />
        </div>
      </div>
    </Dialog>
  )
}

export default ErrorsDialog;
